import React from "react";
import Seo from "components/Seo";
import Introduction from "../../../common/-pages/company/Introduction";
import CompanyLayout from "./companyLayout";

const MorningIntroduction = () => {
    return (
        <React.Fragment>
            <Seo type="morning" pageTitle="회사소개" />
            <CompanyLayout>
                <Introduction />
            </CompanyLayout>
        </React.Fragment>
    );
};

export default MorningIntroduction;
